
export const FETCH_TIMESHEET_APPROVALS_REQUEST = "FETCH_TIMESHEET_APPROVALS_REQUEST";
export const FETCH_TIMESHEET_APPROVALS_SUCCESS = "FETCH_TIMESHEET_APPROVALS_SUCCESS";
export const FETCH_TIMESHEET_APPROVALS_FAILURE = "FETCH_TIMESHEET_APPROVALS_FAILURE";

export const FETCH_TIMESHEET_EMPLOYEE_DETAILS_REQUEST = "FETCH_TIMESHEET_EMPLOYEE_DETAILS_REQUEST";
export const FETCH_TIMESHEET_EMPLOYEE_DETAILS_SUCCESS = "FETCH_TIMESHEET_EMPLOYEE_DETAILS_SUCCESS";
export const FETCH_TIMESHEET_EMPLOYEE_DETAILS_FAILURE = "FETCH_TIMESHEET_EMPLOYEE_DETAILS_FAILURE";

export const UPDATE_TIMESHEET_APPROVAL_REQUEST = "UPDATE_TIMESHEET_APPROVAL_REQUEST";
export const UPDATE_TIMESHEET_APPROVAL_SUCCESS = "UPDATE_TIMESHEET_APPROVAL_SUCCESS";
export const UPDATE_TIMESHEET_APPROVAL_FAILURE = "UPDATE_TIMESHEET_APPROVAL_FAILURE";

export const FETCH_TIMESHEET_HR_APPROVAL_REQUEST = 'FETCH_TIMESHEET_HR_APPROVAL_REQUEST';
export const FETCH_TIMESHEET_HR_APPROVAL_SUCCESS = 'FETCH_TIMESHEET_HR_APPROVAL_SUCCESS';
export const FETCH_TIMESHEET_HR_APPROVAL_FAILURE = 'FETCH_TIMESHEET_HR_APPROVAL_FAILURE';

export const GENERATE_TIMESHEET_HR_APPROVAL_REQUEST = 'GENERATE_TIMESHEET_HR_APPROVAL_REQUEST';
export const GENERATE_TIMESHEET_HR_APPROVAL_SUCCESS = 'GENERATE_TIMESHEET_HR_APPROVAL_SUCCESS';
export const GENERATE_TIMESHEET_HR_APPROVAL_FAILURE = 'GENERATE_TIMESHEET_HR_APPROVAL_FAILURE';

export const SAVE_GENERATED_TIMESHEET_HR_APPROVAL_REQUEST = 'SAVE_GENERATED_TIMESHEET_HR_APPROVAL_REQUEST';
export const SAVE_GENERATED_TIMESHEET_HR_APPROVAL_SUCCESS = 'SAVE_GENERATED_TIMESHEET_HR_APPROVAL_SUCCESS';
export const SAVE_GENERATED_TIMESHEET_HR_APPROVAL_FAILURE = 'SAVE_GENERATED_TIMESHEET_HR_APPROVAL_FAILURE';

export const RESET_TIMESHEET_HR_APPROVALS = 'RESET_TIMESHEET_HR_APPROVALS';

export const FETCH_TIMESHEET_FINAL_APPROVAL_REQUEST = 'FETCH_TIMESHEET_FINAL_APPROVAL_REQUEST';
export const FETCH_TIMESHEET_FINAL_APPROVAL_SUCCESS = 'FETCH_TIMESHEET_FINAL_APPROVAL_SUCCESS';
export const FETCH_TIMESHEET_FINAL_APPROVAL_FAILURE = 'FETCH_TIMESHEET_FINAL_APPROVAL_FAILURE';

export const SAVE_TIMESHEET_FINAL_APPROVAL_REQUEST = 'SAVE_TIMESHEET_FINAL_APPROVAL_REQUEST';
export const SAVE_TIMESHEET_FINAL_APPROVAL_SUCCESS = 'SAVE_TIMESHEET_FINAL_APPROVAL_SUCCESS';
export const SAVE_TIMESHEET_FINAL_APPROVAL_FAILURE = 'SAVE_TIMESHEET_FINAL_APPROVAL_FAILURE';

export const RESET_TIMESHEET_FINAL_APPROVAL = 'RESET_TIMESHEET_FINAL_APPROVAL';

